// Remaining totals in the Step-by-Step Day Overview "Nutrition summary" style
// (GuidedPlanning.jsx renderDayOverview, data-testid="macro-diagnostic").
var CELLS = [
  { key: 'calories', label: 'Calories', unit: '' },
  { key: 'protein', label: 'Protein', unit: 'g' },
  { key: 'carbs', label: 'Carbs', unit: 'g' },
  { key: 'fat', label: 'Fat', unit: 'g' },
];

function BrowseRemainingSummary({ remaining, status, testId, caloriesLabel }) {
  if (!remaining) return null;
  return (
    <div className="p-4 rounded-xl border border-border/30 bg-secondary/20" data-testid={testId}>
      <div className="flex items-center justify-between gap-2 mb-3">
        <span className="text-sm font-bold text-foreground">Remaining to goal</span>
        {status && <span className="text-xs font-medium text-muted-foreground whitespace-nowrap" data-testid={testId + '-status'}>{status}</span>}
      </div>
      <div className="grid grid-cols-4 gap-2">
        {CELLS.map(function(c) {
          return (
            <div key={c.key} className="text-center p-2 rounded-lg bg-background/50">
              <p className="text-xs text-muted-foreground">{c.key === 'calories' && caloriesLabel ? caloriesLabel : c.label}</p>
              <p className="font-mono font-bold" data-testid={testId + '-' + c.key}>{Math.round(remaining[c.key])}{c.unit}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BrowseRemainingSummary;
